export default __webpack_public_path__ + "static/media/12.873289c9.jpg";